var map = {
	"./Images/Cover_BadDesitions.png": 5350,
	"./Images/Rectangle.png": 3764,
	"./Images/Teide.png": 4728,
	"./Images/cover_Chosen.png": 4681,
	"./Images/cover_aquaregia.jpeg": 2176,
	"./Images/cover_burnthewitch.jpeg": 9355,
	"./Images/icon_Arrow_top_right.svg": 379,
	"./Images/icon_arrow_download.svg": 4787,
	"./Images/icon_arrow_left.svg": 2288,
	"./Images/icon_arrow_right.svg": 1023,
	"./Images/icon_arrow_right_simple.svg": 1620,
	"./Images/icon_arrow_top.svg": 8700,
	"./Images/icon_arrow_top_left.svg": 6964,
	"./Images/icon_close.svg": 4723,
	"./Images/icon_music_player_next.svg": 9170,
	"./Images/icon_music_player_pause.svg": 2101,
	"./Images/icon_music_player_play.svg": 1487,
	"./Images/icon_music_player_prev.svg": 8990,
	"./Images/icon_sound.svg": 8894,
	"./Images/icon_sound_negative.svg": 7600,
	"./Images/icon_star.svg": 8221,
	"./Images/icon_video_pause.svg": 2809,
	"./Images/logo_negative.svg": 8270,
	"./Images/project-APPS-principal-image.png": 790,
	"./Images/project-BMAKER-principal-image.png": 9264,
	"./Images/project-PLAY-principal-image.png": 5680,
	"./Images/project-SMARTBOOQS-principal-image.png": 4755,
	"./Images/projectAnimation01.png": 5381,
	"./Images/projectAnimation02.png": 7550,
	"./Images/projectAnimation03.png": 7047,
	"./Images/projectAnimation04.png": 4904,
	"./Images/projectBG01.png": 6504,
	"./Images/projectBG01_Landscape.png": 4862,
	"./Images/projectBG02.png": 2259,
	"./Images/projectBG02_landscape.jpg": 1613,
	"./Images/projectBG02_landscape.png": 973,
	"./Images/projectBG03.png": 7050,
	"./Images/projectBG04.png": 277,
	"./Images/projectBG04_landscape.png": 8991,
	"./Images/yo-banner-negro-movil.jpg": 5750,
	"./Images/yo-banner-negro.png": 6664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8288;